const defaultTiming = '0.5s ease';
const bgTransition = `background ${defaultTiming}`;
const colorTransition = `color ${defaultTiming}`;
const defaultTransition = `${bgTransition}, ${colorTransition}`;

const transitions = {  // fix warning  Assign object to a variable before exporting as module default  import/no-anonymous-default-export
  DEFAULT: defaultTransition,
  COLOR: colorTransition,
  BACKGROUND: bgTransition,
  ALL: defaultTiming,
};

export default transitions;
